import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from "primeng/button";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { RouterLink } from "@angular/router";
import { ContentDesktopButtonTooltipDirective } from "../../tooltip/content-desktop-button-tooltip.directive";
import { UserSpaceBtnComponent } from "./user-space-btn.component";

@Component({
  selector: 'ra-self-offers-btn',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    OverlayPanelModule,
    RouterLink,
    ContentDesktopButtonTooltipDirective,
    UserSpaceBtnComponent,
  ],
  template: `
    <ra-user-space-btn
      idleColor="transparent"
      svgChangeColor="stroke"
      svgUrl="/assets/icons/header/user-space/my-offers.svg"
      (click)="SelfOffersLinksPanel.show($event)"
      [active]="isActive"
      tooltipText="Мои объявления"
    ></ra-user-space-btn>

    <p-overlayPanel #SelfOffersLinksPanel>
      <ng-template pTemplate>
        <div
          class="bg-white rounded-lg shadow flex-col justify-start items-start flex"
          (mouseleave)="SelfOffersLinksPanel.hide();"
        >
          <div
            class="last:border-0 w-full pl-3.5 pr-[60px] py-2 border-[1px] border-b border-t-0 border-x-0 border-solid border-gray-200 justify-start items-center gap-2 inline-flex"
          >
            <a
              routerLink="/lk/transport/rent/my-offers"
              (click)="SelfOffersLinksPanel.hide();"
              class="text-center text-slate-950 text-sm font-normal leading-tight"
              >Транспорт</a
            >
          </div>
          <div
            class="last:border-0 w-full pl-3.5 pr-[60px] py-2 border-[1px] border-b border-t-0 border-x-0 border-solid border-gray-200 justify-start items-center gap-2 inline-flex"
          >
            <a
              routerLink="/lk/com-transport/rent/my-offers"
              (click)="SelfOffersLinksPanel.hide();"
              class="text-center text-slate-950 text-sm font-normal leading-tight"
              >Спецтехника</a
            >
          </div>
        </div>
      </ng-template>
    </p-overlayPanel>
  `,
  styles: `
    :host {
        @apply mr-1;
    }
  `,
})
export class SelfOffersBtnComponent {
  isActive = false;
}
